module.exports = __webpack_public_path__ + "img/logo_green.c75384ef.webp";